<template>
  <div>
    <create-content-layout :title="'ایجاد درس جدید'" :submitFunction="CreateContent"></create-content-layout>
  </div>
</template>
<script>
import CreateContentLayout from "./CreateLayoutForLesson";
import {mapActions} from 'vuex';

export default {
  name: "CreateContent",
  components: {CreateContentLayout},
  methods: {
    ...mapActions({
      CreateContent: "Content/createContent"
    })
  }
}
</script>